export default __webpack_public_path__ + "static/media/bike-computer-za-site-3.7143f68f.jpg";